module.exports = __webpack_public_path__ + "img/tapuah_yes.9d1b32ec.png";